<template>
    <div id="app-footer" class="sticky bottom-0 border-t w-full bg-gray-100 rounded-t-lg" style="z-index: 150">
        <div class="footer-content p-2">
            <div class="flex flex-row items-center justify-between">
                <div class="flex items-center">
                    <slot name="left"></slot>
                </div>
                <div class="flex items-center">
                    <slot name="right"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
defineProps({
    // You can define props here if needed in the future
});
</script>

<style scoped>
/* #app-footer {
    background-color: #f0f0f0;
    box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
} */
</style>
